import { Box, Checkbox, Typography, Grid } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { Fragment } from "react";
import { SchemeData } from ".";
import { CartItemSipNew } from "../../../../store/actions";
import Image from "../../../Image";
import { CartItemProps } from "../useInvestorCart";
import { convertDateToIndian, convertToInr } from "../../../../utils/cart";

export const StpCartItem: CartItemProps<"STP"> = function (props) {
  const {
    cartId,
    cartItemId,
    editCartItem,
    fundCode,
    isSelected,
    payload,
    removeCartItem,
    selectCartItem,
  } = props;

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            checked={isSelected}
            onChange={() => selectCartItem(cartItemId)}
            style={{ color: "#2057A6" }}
          />
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
              fontWeight: "bolder",
              color: "rgba(0, 124, 197, 1)",
            }}
          >
            Switch In Scheme
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            padding: "10px",
          }}
        >
          <Image
            src="/images/edit_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => editCartItem(cartId, cartItemId, fundCode)}
          />
          <Image
            src="/images/delete_cart.svg"
            style={{ width: "24px", cursor: "pointer", margin: "5px" }}
            onClick={() => removeCartItem(cartId, cartItemId)}
          />
        </Box>
      </Box>
      <Box display={"flex"} flexDirection={"column"} paddingLeft={"40px"}>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
          }}
        >
          {payload?.switchInSchemeName}
        </Typography>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
            color: "rgba(1, 132, 69, 1)",
            marginTop: "10px",
          }}
        >
          Switch Out Scheme
        </Typography>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {payload?.switchOutSchemeName}
        </Typography>
      </Box>

      <Grid container style={{ paddingLeft: "40px" }}>
        <Grid item xs={12} lg={9}>
          <Grid container>
            <SchemeData name="Folio" value={payload.folio} />
            <SchemeData
              name="Start date"
              value={convertDateToIndian(payload.stpStartDate)}
            />
            <SchemeData
              name="End date"
              value={convertDateToIndian(payload.stpEndDate)}
            />
            <SchemeData name="STP Option" value={payload.stpOption} />
            <SchemeData name="EUIN" value={payload.euin} />
          </Grid>
        </Grid>
        {payload.stpOption === "F" || payload.stpOption === "Fixed" ? (
          <Grid item xs={12} lg={3}>
            <SchemeData name="Amount" value={convertToInr(payload.amount)} />
          </Grid>
        ) : null}
      </Grid>
    </Fragment>
  );
};
export const StpSummaryItem = ({ payload, ...rest }: CartItemSipNew) => {
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography
            style={{
              fontSize: "16px",
              fontFamily: "Open Sans",
              fontWeight: "bolder",
              color: "rgba(0, 124, 197, 1)",
            }}
          >
            Switch In Scheme
          </Typography>
        </Box>
      </Box>
      <Box display={"flex"} flexDirection={"column"} paddingLeft={"40px"}>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
          }}
        >
          {/* @ts-igonre */}
          {payload?.switchInSchemeName}
        </Typography>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
            color: "rgba(1, 132, 69, 1)",
            marginTop: "10px",
          }}
        >
          Switch Out Scheme
          {/* Switch Out Scheme */}
        </Typography>
        <Typography
          style={{
            fontSize: "16px",
            fontFamily: "Open Sans",
            fontWeight: "bolder",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {payload?.switchOutSchemeName}
        </Typography>
      </Box>

      <Grid container style={{ paddingLeft: "40px" }}>
        <Grid item xs={12} lg={9}>
          <Grid container>
            <SchemeData name="Folio" value={payload.folio} />
            <SchemeData name="STP Type" value={payload.stpOption} />
            <SchemeData name="STP Day" value={payload.stpDay} />
            <SchemeData name="No.of Transfers" value={payload.noOfTransfers} />
            <SchemeData
              name="Start date"
              value={new Date(payload.stpStartDate).toLocaleDateString(
                "en-IN",
                {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                }
              )}
            />
            <SchemeData
              name="End date"
              value={new Date(payload.stpEndDate).toLocaleDateString("en-IN", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })}
            />
            <SchemeData name="STP Option" value={payload.stpOption} />
          </Grid>
        </Grid>
        {payload.stpOption === "F" || payload.stpOption === "Fixed" ? (
          <Grid item xs={12} lg={3}>
            <SchemeData name="Amount" value={"\u20B9" + payload.amount} />
          </Grid>
        ) : null}
      </Grid>
    </Fragment>
  );
};
